import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraFieldSchemeAri } from '@atlassian/ari/jira/field-scheme';
import { fg } from '@atlassian/jira-feature-gating';
import FieldSchemePageQuery from './__generated__/FieldSchemePageQuery.graphql';

export const globalAdminFieldSchemeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-jira-admin-pages-field-scheme" */ './FieldSchemeApp.tsx'),
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			fieldSchemePageQuery: {
				parameters: FieldSchemePageQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					schemeId: fg('efa_cmp_-_beta_fields_management_features')
						? match.params?.schemeId || ''
						: '',
					input: {
						schemeId: match.params?.schemeId || '',
					},
					fieldSchemeAri: match.params?.schemeId
						? JiraFieldSchemeAri.create({
								siteId: tenantContext.cloudId,
								activationId: tenantContext.activationId,
								fieldSchemeId: match.params.schemeId,
							}).toString()
						: '',
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
		extraProps: {
			schemeId: match.params?.schemeId || '',
		},
	}),
});
